import {h, Fragment} from "preact"
import Product from "./Product"
import ProductPlaceholder from "./ProductPlaceholder"

export default function LoadingPlaceholder() {
    return (
        <>
        <div class="flex justify-between px-12 py-12 lg:px-0"> 
            <div class="placeholder-h-facet-bar animate-pulse w-full"></div> 
        </div>
        <div className="product-grid-large" id="ProductGridContainer">
            {/* <div class="hidden lg:flex justify-between px-12 py-12 lg:px-24 animate-pulse">
                <div class="placeholder-h-facet-bar-mobile bg-image animate-pulse w-full lg:h-40"></div>
            </div> */}
            <ul id="product-grid" role="list">
                {
                    [...Array(8)].map((_, index) => (
                        <ProductPlaceholder key={index} />
                    ))
                }
            </ul>
        </div>
        </>
    )
}
